// translations
const i18n = Object.freeze({
  RATE_PERIOD: (days: number) => `Last ${days} days`,
});

export default i18n;
